import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export function TasksPage() {
  const qc = useQueryClient();
  const [openOnly, setOpenOnly] = useState(true);
  const tasksQ = useQuery({ queryKey: ["tasks", openOnly], queryFn: () => api.listTasks(openOnly) });
  const toggle = useMutation({
    mutationFn: (p: { id: number; done: boolean }) => api.toggleTask(p.id, p.done),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["tasks"] }),
  });

  if (tasksQ.isLoading) return <div>Загрузка…</div>;

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Задачи</h2>
        <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13 }}>
          <input type="checkbox" checked={openOnly} onChange={(e) => setOpenOnly(e.target.checked)} />
          только открытые
        </label>
      </div>
      <div className="panel">
        {(tasksQ.data || []).length === 0 && <div style={{ color: "var(--muted)" }}>Пусто</div>}
        {(tasksQ.data || []).map((t) => (
          <div key={t.id} className={`task ${t.done_at ? "done" : ""}`}>
            <span>
              <input
                type="checkbox"
                checked={Boolean(t.done_at)}
                onChange={(e) => toggle.mutate({ id: t.id, done: e.target.checked })}
                style={{ marginRight: 8 }}
              />
              {t.title}{" "}
              {(t as unknown as { lead_id?: number }).lead_id && (
                <Link to={`/lead/${(t as unknown as { lead_id: number }).lead_id}`} style={{ marginLeft: 8, fontSize: 11 }}>
                  → лид
                </Link>
              )}
            </span>
            <span style={{ fontSize: 11, color: "var(--muted)" }}>
              {t.due_at ? new Date(t.due_at).toLocaleString("ru-RU") : ""}
            </span>
          </div>
        ))}
      </div>
    </>
  );
}
